import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import Cookies from "js-cookie";
import { db } from "../../firebase.js";
import logo_default from "../../assets/logo_default.jpg";
import { Toast } from '../../components_root/ToastContext.jsx';
import CopyUID from "../../components_root/copyuid.jsx";
import Ledger_account_profile_popup from "./ledger_account_profile_popup.jsx";
import { Verify_accountgroup } from "../../accounting_root/Verify_accountgroup.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Ledger_accounts_profile({ accountguid }) {
    const { Toastshow } = Toast();
    const [IsLoading2, setIsLoading2] = useState(true);
    const navigate = useNavigate();
    const [account_data, setAccount_data] = useState([]);
    const servicetablename = "companies";
    const [profileopen, setProfileopen] = useState(false);

    const fetch_accounts = () => {
        if (!accountguid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        const ledgerQuery = query(
            collection(db, servicetablename, select_company_uid, "staff_accounts"),
            where("accountguid", "==", accountguid)
        );

        const unsubscribe = onSnapshot(
            ledgerQuery,
            async (snapshot) => {
                // ✅ if companies/staff_accounts has data
                if (!snapshot.empty) {
                    const ledgerDocs = snapshot.docs;
                    const mergedData = await Promise.all(
                        ledgerDocs.map(async (docSnap) => {
                            const ledgerData = { id: docSnap.id, ...docSnap.data() };

                            const accountDoc = await getDocs(
                                query(
                                    collection(db, "accounts"),
                                    where("guid", "==", accountguid)
                                )
                            );
                            let accountInfo = {};
                            if (!accountDoc.empty) {
                                accountInfo = {
                                    account_id: accountDoc.docs[0].id,
                                    ...accountDoc.docs[0].data(),
                                };
                            }
                            return {
                                ...ledgerData,
                                account_info: accountInfo
                            };
                        })
                    );
                    setAccount_data(mergedData);
                    setIsLoading2(false);
                    return;
                }
                // ✅ ELSE: fallback to accountingfinancedb/ledger_accounts
                const fallbackQuery = query(
                    collection(db, "accountingfinancedb", select_company_uid, "ledger_accounts"),
                    where("accountguid", "==", accountguid)
                );
                const fallbackSnap = await getDocs(fallbackQuery);
                const mergedData = await Promise.all(
                    fallbackSnap.docs.map(async (docSnap) => {
                        const ledgerData = { id: docSnap.id, ...docSnap.data() };
                        return {
                            ...ledgerData,
                            account_info: ledgerData
                        };
                    })
                );
                setAccount_data(mergedData);
                setIsLoading2(false);
            },
            (error) => {
                console.error("Error fetching accounts:", error);
                setIsLoading2(false);
            }
        );
        return unsubscribe;
    };
    useEffect(() => {
        fetch_accounts();
    }, [accountguid]);
    //qaqxusal3bwr0ebk
    const [verifiedGroup, setVerifiedGroup] = useState(
        account_data?.[0]?.account_type || ""
    );


    useEffect(() => {
    const groupid = account_data?.[0]?.account_type;

    if (!groupid) {
        setVerifiedGroup("");
        return;
    }

    const verifyGroup = async () => {
        const res = await Verify_accountgroup(groupid);

        if (res?.success) {
            setVerifiedGroup(res.data?.account_type || "");
        } else {
            setVerifiedGroup("");
            console.error(res?.error);
        }
    };

    verifyGroup();

}, [account_data?.[0]?.account_type]);
    // useEffect(() => {
    //     const groupid = account_data?.[0]?.account_type;

    //     if (!groupid) {
    //         setVerifiedGroup("");
    //         return;
    //     }

    //     const fetchGroup = async () => {
    //         try {
    //             const masterQuery = query(
    //                 collection(db, "accounting_groups_list_master"),
    //                 where("groupid", "==", groupid)
    //             );

    //             const snapshot = await getDocs(masterQuery);

    //             if (!snapshot.empty) {
    //                 setVerifiedGroup(
    //                     snapshot.docs[0]?.data()?.account_type || ""
    //                 );
    //             } else {
    //                 setVerifiedGroup(groupid);
    //             }
    //         } catch (error) {
    //             console.error("Error fetching verified group:", error);
    //             setVerifiedGroup("");
    //         }
    //     };

    //     fetchGroup();
    // }, [account_data?.[0]?.account_type]);

    // const [verifiedGroup, setVerifiedGroup] = useState([]);
    //        useEffect(() => {
    //             const masterQuery = query(
    //                 collection(db, "accounting_groups_list_master"),
    //                 where("groupid", "==", account_data[0]?.account_type)
    //             );

    //             const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
    //                 const rawList = snapshot.docs.map((d) => d.data());

    //            //    setVerifiedGroup(rawList); // 👈 keep raw

    //             });

    //             return () => unsubscribeMaster();
    //         },[account_data?.[0]?.account_type]);
    // useEffect(() => {
    //     const q = query(
    //         collection(db, "accounting_groups_list_master"),
    //         where("groupid", "==", "qaqxusal3bwr0ebk")
    //     );

    //     const unsub = onSnapshot(q, (snapshot) => {
    //         const list = snapshot.docs.map(doc => ({
    //             id: doc.id,
    //             ...doc.data()
    //         }));
    //         setVerifiedGroup(list);
    //     });

    //     return () => unsub();
    // }, []);
    //
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    const toggleProfile = () => {
        setProfileopen(prev => !prev);
    };
    return (
        <div >
            <div   >
                <table>
                    <tr>
                        <td>
                            <table>
                                <tr>
                                    <td onClick={toggleProfile}>
                                        <img className="icon-photo b-1 rounded-circle items-back-fill"
                                            src={
                                                account_data[0]?.account_info?.photoURL ||
                                                logo_default
                                            }
                                            alt="photo"
                                        onError={(e) => {
                                            e.currentTarget.src = logo_default;
                                        }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-h3 bold fcap">
                                            {verifiedGroup.replaceAll("_", " ")}

                                        </div>
                                    </td>
                                </tr>

                            </table>

                        </td>
                        <td>
                            <table>
                                <tr>
                                    <td className="text-h2 bold fcap">
                                        {account_data[0]?.account_info?.name || "N/A"}
                                    </td>
                                </tr>
 <tr>
                                    <td className="text-h2 text-off fcap">
                                        {account_data[0]?.account_info?.account_role_type || "N/A"}
                                    </td>
                                </tr>

                                <tr className="flex">
                                    <td className="text-h3 text-off">
                                        <table>
                                            <tr>
                                                <td>{account_data[0]?.accountnumber || "N/A"}</td>
                                                <td width={30}><CopyUID id={account_data[0]?.accountnumber} /></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    {account_data?.[0]?.mobile &&
                                        account_data?.[0]?.mobile.length >= 10 && (
                                            <td width={100} className="text-h2 text-off">
                                                <table >
                                                    <tr>
                                                        <td >{account_data[0]?.account_info?.code}{account_data[0]?.account_info?.mobile || "N/A"}</td>
                                                        <td width={30}><CopyUID id={account_data[0]?.mobile || account_data[0]?.account_info?.mobile || "N/A"} /></td>
                                                    </tr>
                                                </table>
                                            </td>
                                        )
                                    }

                                </tr>

                            </table>
                        </td>
                    </tr>
                </table>

            </div>
            <Ledger_account_profile_popup
                data={accountguid}
                isOpen={profileopen}
                onClose={() => setProfileopen(false)} />
        </div >
    );
}
